import { atom } from "recoil";

const organizationDataState = atom({
  key: "organizationDataState",
  default: null,
});

export default organizationDataState;
